// Zentrale API-Konfiguration
//
// Die Adressen kommen aus der .env bzw. aus Build-Argumenten. Hier standen
// frueher die Adressen einer bestimmten Installation als Vorbelegung — ein
// Build ohne Konfiguration sprach damit unbemerkt gegen fremde, produktive
// Systeme.
//
// Achtung, Create React App: Diese Werte werden BEIM BAUEN eingesetzt, nicht
// zur Laufzeit. Nach einer Aenderung an der .env muss `npm start` neu
// gestartet bzw. `npm run build` erneut ausgefuehrt werden. Uebernommen
// werden nur Variablen mit dem Praefix REACT_APP_.

// ThingsBoard laeuft auf einem eigenen Host — dafuer gibt es keine sinnvolle
// Vorbelegung. Fehlt der Wert, gingen die Anfragen an den eigenen Ursprung
// und damit ins Leere; der Docker-Build bricht deshalb vorher ab (Dockerfile).
export const API_BASE = process.env.REACT_APP_TB_API_BASE || '';

// Leer heisst: gleicher Ursprung wie diese App. Genau so steht es im
// Betrieb — der Ingress leitet /api, /docs, /health und /openapi.json
// desselben Hosts an den BFF. Ein eigener Wert ist nur noetig, wenn der BFF
// woanders liegt (z.B. lokal auf Port 8010).
export const API_BASE_IOTHUB = process.env.REACT_APP_BFF_BASE || '';

if (!API_BASE) {
  // Kein throw: Die App soll starten, damit der Fehler im Browser sichtbar
  // wird und nicht als weisse Seite ohne Hinweis endet.
  console.error(
    'REACT_APP_TB_API_BASE ist nicht gesetzt — ThingsBoard-Aufrufe schlagen fehl. ' +
    'Siehe .env.example.'
  );
}

export function authHeaders(token) {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}
